import { Component, ComponentInterface, Prop } from '@stencil/core';

@Component({ tag: 'uni-date' })
export class UniDateComponent implements ComponentInterface {

  @Prop({ reflect: true }) year: boolean = false;

  render(): string {
    const date: string = new Date().toDateString();
    const year: string = date.split(' ')[3];

    return this.year ? year : null;
  }
}
